import { NavLink } from "react-router-dom";
import {
  ChevronLeft,
  ChevronRight,
  User,
  Plus,
  Eye,
  Newspaper,
  Calendar,
  FileText,
  Users
} from "lucide-react";
import { useState } from "react";

const Sidebar = ({ collapse, setCollapse }) => {
  const [expandedMenu, setExpandedMenu] = useState(null);

  const toggleMenu = (menu) => {
    setExpandedMenu(expandedMenu === menu ? null : menu);
  };

  return (
    <div
      className={`bg-white shadow-md flex flex-col justify-between transition-all duration-300 ${
        collapse ? "w-16" : "w-64"
      }`}
    >
      <div>

        {/* USER */}
        <div className="flex items-center justify-between p-3 border-b">
          <div className="flex items-center">
            <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center">
              <User className="w-5 h-5 text-gray-600" />
            </div>

            {!collapse && <span className="ml-3 font-medium">Login</span>}
          </div>

          <button
            onClick={() => setCollapse(!collapse)}
            className="p-2 hover:bg-gray-200 rounded-full"
          >
            {collapse ? <ChevronRight /> : <ChevronLeft />}
          </button>
        </div>

        <ul>

          {/* NEWS */}
          <li>
            <button
              onClick={() => toggleMenu("news")}
              className="flex items-center w-full p-3 hover:bg-gray-100"
            >
              <Newspaper className="w-5 h-5" />
              {!collapse && <span className="ml-3 flex-1">News</span>}
              {!collapse &&
                (expandedMenu === "news" ? <ChevronLeft /> : <ChevronRight />)}
            </button>

            {!collapse && expandedMenu === "news" && (
              <ul className="ml-8">

                <li>
                  <NavLink
                    to="/dashboard/news/create-news"
                    className="flex items-center p-2 hover:bg-gray-100 rounded"
                  >
                    <Plus className="w-4 h-4 mr-2" />
                    Create News
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/dashboard/news/read-news"
                    className="flex items-center p-2 hover:bg-gray-100 rounded"
                  >
                    <Eye className="w-4 h-4 mr-2" />
                    Read News
                  </NavLink>
                </li>

              </ul>
            )}
          </li>


          {/* PROGRAMS */}
          <li>
            <button
              onClick={() => toggleMenu("programs")}
              className="flex items-center w-full p-3 hover:bg-gray-100"
            >
              <Calendar className="w-5 h-5" />
              {!collapse && <span className="ml-3 flex-1">Programs</span>}
              {!collapse &&
                (expandedMenu === "programs" ? <ChevronLeft /> : <ChevronRight />)}
            </button>

            {!collapse && expandedMenu === "programs" && (
              <ul className="ml-8">

                <li>
                  <NavLink
                    to="programs/create-programs"
                    className="flex items-center p-2 hover:bg-gray-100 rounded"
                  >
                    <Plus className="w-4 h-4 mr-2" />
                    Create Program
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="programs/read-programs"
                    className="flex items-center p-2 hover:bg-gray-100 rounded"
                  >
                    <Eye className="w-4 h-4 mr-2" />
                    Read Programs
                  </NavLink>
                </li>

              </ul>
            )}
          </li>


          {/* SCHEMES */}
          <li>
            <button
              onClick={() => toggleMenu("schemes")}
              className="flex items-center w-full p-3 hover:bg-gray-100"
            >
              <FileText className="w-5 h-5" />
              {!collapse && <span className="ml-3 flex-1">Schemes</span>}
              {!collapse &&
                (expandedMenu === "schemes" ? <ChevronLeft /> : <ChevronRight />)}
            </button>

            {!collapse && expandedMenu === "schemes" && (
              <ul className="ml-8">

                <li>
                  <NavLink
                    to="/dashboard/schemes/create-scheme"
                    className="flex items-center p-2 hover:bg-gray-100 rounded"
                  >
                    <Plus className="w-4 h-4 mr-2" />
                    Create Scheme
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/dashboard/schemes/read-scheme"
                    className="flex items-center p-2 hover:bg-gray-100 rounded"
                  >
                    <Eye className="w-4 h-4 mr-2" />
                    Read Schemes
                  </NavLink>
                </li>

              </ul>
            )}
          </li>


          {/* BODY MEMBERS */}
          <li>
            <button
              onClick={() => toggleMenu("body-members")}
              className="flex items-center w-full p-3 hover:bg-gray-100"
            >
              <Users className="w-5 h-5" />
              {!collapse && <span className="ml-3 flex-1">Body Members</span>}
              {!collapse &&
                (expandedMenu === "body-members"
                  ? <ChevronLeft />
                  : <ChevronRight />)}
            </button>

            {!collapse && expandedMenu === "body-members" && (
              <ul className="ml-8">

                <li>
                  <NavLink
                    to="/dashboard/body-members/create-body-members"
                    className="flex items-center p-2 hover:bg-gray-100 rounded"
                  >
                    <Plus className="w-4 h-4 mr-2" />
                    Create Member
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/dashboard/body-members/read-body-members"
                    className="flex items-center p-2 hover:bg-gray-100 rounded"
                  >
                    <Eye className="w-4 h-4 mr-2" />
                    Read Members
                  </NavLink>
                </li>

              </ul>
            )}
          </li>

        </ul>
      </div>

      <div className="p-3 border-t text-center text-sm text-gray-500">
        {!collapse && "© 2025 MyApp"}
      </div>
    </div>
  );
};

export default Sidebar;